// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"99598e2f","417":"2da6baad","776":"028e431d","797":"6b193062","914":"4042432b"}[chunkId] + ".chunk.js";
};